import React from 'react';
import { Pagination, Empty, Spin } from 'antd';
import './OptimizedList.css';

const OptimizedList = ({ 
  data = [], 
  loading = false, 
  pageSize = 10, 
  current = 1, 
  total = 0, 
  onPageChange, 
  renderItem, 
  emptyText = "Nenhum item encontrado",
  className = "",
  style = {},
  gridMode = false
}) => {

  return (
    <div className={`optimized-list-container ${className}`}>
      {/* Lista de conteúdo */}
      <div className="optimized-list-content">
        {loading ? (
          <div className="optimized-list-loading">
            <Spin size="large" />
          </div>
        ) : data.length === 0 ? (
          <div className="optimized-list-empty">
            <Empty 
              description={emptyText}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          </div>
        ) : (
          <div className={gridMode ? "optimized-list-grid" : "optimized-list-list"}>
            {data.map((item, index) => {
              const renderedItem = renderItem(item, index);
              return renderedItem ? (
                <div className="optimized-list-item">
                  {renderedItem}
                </div>
              ) : null;
            })}
          </div>
        )}
      </div>

      {/* Paginação fixa na base */}
      {total > pageSize && (
        <div className="optimized-list-pagination-container">
          <Pagination
            current={current}
            pageSize={pageSize}
            total={total}
            onChange={onPageChange}
            showSizeChanger={false}
            showQuickJumper={false}
            showTotal={(total, range) => 
              `${range[0]}-${range[1]} de ${total} itens`
            }
            className="optimized-list-pagination"
            responsive={true}
          />
        </div>
      )}
    </div>
  );
};

export default OptimizedList;
